import common from '@/util/common';
import {
	createNamespacedHelpers
} from 'vuex';
const sroreName = {
	selectLoginWay: 'selectLoginWay',
};
const {
	mapActions
} = createNamespacedHelpers(sroreName.selectLoginWay);
export default {
	data() {
		return {
			discount_txt: '',
			discount_txt_head: '',
			is_discount: false,
			discount: ''
		};
	},
	components: {
	},
	mounted() {
		this.getConfInfo();
	},
	watch: {
		
	},
	methods: {
		...mapActions({
			getConf: 'getConf',
		}),
		async getConfInfo(){
			const getConfData = await this.getConf({
				content: this
			});
			let discount_txt = common.formateBerakStr(getConfData.data.discount_txt,this.discount_txt);
			let discount_txt_attr = discount_txt.split('<br/>');
			this.discount_txt_head = (discount_txt_attr.shift()).replace('：','');
			this.discount_txt = discount_txt_attr.join('<br/>');
			this.is_discount = getConfData.data.is_discount;
			this.discount = getConfData.data.discount;
			console.log(1111111,getConfData.data.discount_txt,this.discount_txt,this.discount_txt_head);
		},
		bankLogin(){
			window.location.href = 'https://i.xiu.ccb.com/v3/q/87gq8f/';
		},
		wxLogin(){
			common.jump(this,'/',{
				isWxLoginFlag: '1'
			},'query');
		},
	}
};
